import { comma, round, numOrZero } from './legoDigitFilter';
import byteFilter from './legoByteFilter';

export default {
  install: (Vue) => {
    Vue.config.globalProperties.$filters = {
      ...Vue.config.globalProperties.$filters,
      byteFilter,
      comma,
      round,
      numOrZero
    }
  },
};
